/**
 * Bagliore al tocco sui pulsanti pieni: salva il punto toccato in --tx/--ty e accende la classe `ml-glow-on`
 * (lo stile è in styles/hig-mobile.css). Un solo listener globale, nessun costo se non si tocca nulla.
 */
const GLOW = 'button[class*="bg-primary"], button[class*="bg-emerald-600"], button[class*="bg-destructive"], button[data-glow]';

export function installTapEffects() {
  if (typeof document === "undefined") return;
  let active: HTMLElement | null = null;
  const off = () => {
    const el = active;
    active = null;
    if (el) window.setTimeout(() => el.classList.remove("ml-glow-on"), 120);
  };
  document.addEventListener(
    "pointerdown",
    (e) => {
      const el = (e.target as HTMLElement | null)?.closest?.<HTMLElement>(GLOW);
      if (!el || (el as HTMLButtonElement).disabled) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty("--tx", `${e.clientX - r.left}px`);
      el.style.setProperty("--ty", `${e.clientY - r.top}px`);
      el.classList.add("ml-glow-on");
      active = el;
    },
    { passive: true },
  );
  document.addEventListener("pointerup", off, { passive: true });
  document.addEventListener("pointercancel", off, { passive: true });
  document.addEventListener("scroll", off, { passive: true, capture: true });
}
